import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminampa-cuotas-socios',
  templateUrl: './adminampa-cuotas-socios.component.html',
  styleUrls: ['./adminampa-cuotas-socios.component.scss']
})
export class AdminampaCuotasSociosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminampa-cuotas-socios/adminampa-cuotas-socios.component.ts